import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../AuthContext";
import { AiFillEdit } from "react-icons/ai";
import { Modal, Button } from "react-bootstrap";
import { API_BASE_URL } from "../../config";

const SalePOPUP = ({
  edit_id,
  edit_qty,
  edit_price,
  edit_type,
  edit_total,
  edit_customer_name,
  edit_customer_mobile,
}) => {
  const { logout } = useAuth();
  const [calculator, setCalculator] = useState({
    token: localStorage.getItem("authToken"),
    edit_id: edit_id ? edit_id : "",
    qty: edit_qty ? edit_qty : "",
    price: edit_price ? edit_price : "210",
    type: edit_type ? edit_type : "oil_ltr",
    customer_name: edit_customer_name ? edit_customer_name : "",
    customer_mobile: edit_customer_mobile ? edit_customer_mobile : "",
    total: edit_total ? edit_total : "",
  });

  const [showSalePOPUP, setShowSalePOPUP] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;

    setCalculator((prev) => {
      const updated = {
        ...prev,
        [name]: value,
      };

      if (name === "type") {
        // Update prices based on selected type
        const prices = {
          oil_ltr: "210",
          oil_kg: "220",
          oil_bottle_1l: "1150",
          oil_bottle_5l: "5000",
          oil_bottle_15l: "14000",
          cake: "1800",
          groundnut: "3000",
        };
        updated.price = prices[value] || "0";
      }

      if (updated.price && updated.qty) {
        updated.total =
          (Number(updated.price) || 0) * (Number(updated.qty) || 0);
      } else {
        updated.total = 0;
      }

      return updated;
    });
  };

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [lastSaleLoading, setLastSaleLoading] = useState(false);
  const [lastSaleError, setLastSaleError] = useState("");

  const fetchLastSaleForCustomer = useCallback(
    async (customerName, customerMobile) => {
      if ((!customerName && !customerMobile) || edit_id) return;

      setLastSaleLoading(true);
      setLastSaleError("");

      try {
        const response = await axios.post(
          `${API_BASE_URL}/api/sales/last`,
          {
            customer_name: customerName,
            customer_mobile: customerMobile,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data?.status && response.data?.data) {
          const lastSale = response.data.data;
          setCalculator((prev) => ({
            ...prev,
            customer_name: lastSale.customer_name || prev.customer_name,
            customer_mobile: lastSale.customer_mobile || prev.customer_mobile,
            type: lastSale.type || prev.type,
            price: lastSale.price || prev.price,
            qty: lastSale.qty || prev.qty,
            total: lastSale.total || prev.total,
          }));
        }
      } catch (err) {
        setLastSaleError(
          err.response?.data?.message || "Failed to load customer last sale."
        );
      } finally {
        setLastSaleLoading(false);
      }
    },
    [edit_id]
  );

  useEffect(() => {
    if (edit_id) return;

    const timer = setTimeout(() => {
      const name = calculator.customer_name?.trim();
      const mobile = calculator.customer_mobile?.trim();
      if (name || mobile) {
        fetchLastSaleForCustomer(name, mobile);
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [calculator.customer_name, calculator.customer_mobile, edit_id, fetchLastSaleForCustomer]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess("");

    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/salesave`,
        calculator,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            "X-Requested-With": "XMLHttpRequest",
          },
        },
      );

      setSuccess("Item added successfully!");
      setLoading(false);
      window.location.reload();
    } catch (error) {
      if (error?.response?.status === 401) {
        logout();
        navigate("/");
      } else {
        setLoading(false);
        setError(
          error?.response?.data?.message ||
            error?.response?.data?.error ||
            "Failed to save sale.",
        );
      }
    }
  };

  const handleOpenSalePOPUP = () => setShowSalePOPUP(true);
  const handleCloseSalePOPUP = () => setShowSalePOPUP(false);

  return (
    <div className="money_counter">
      {edit_id ? (
        <span className="bt-calculeter" onClick={handleOpenSalePOPUP}>
          <AiFillEdit />
        </span>
      ) : (
        <button
          className="bt-calculeter mt-2 p-2 bg-green-500 text-white rounded"
          onClick={handleOpenSalePOPUP}
        >
          Add Product
        </button>
      )}

      <Modal show={showSalePOPUP} onHide={handleCloseSalePOPUP}>
        <Modal.Header closeButton>
          <Modal.Title>{edit_id ? "Edit Sale" : "Add Sale"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row top-aj">
            <div className="form-group col-12">
              <input
                type="hidden"
                name="edit_id"
                className="form-control"
                value={calculator.edit_id}
                onChange={handleChange}
                required
              />
              <select
                onChange={handleChange}
                className="border p-2 rounded col-12 mb-3"
                required
                name="type"
                value={calculator.type}
              >
                <option value="oil_ltr">Oil (Liter)</option>
                <option value="oil_kg">Oil (Kilogram)</option>
                <option value="oil_bottle_1l">Oil Bottle (1L)</option>
                <option value="oil_bottle_5l">Oil Bottle (5L)</option>
                <option value="oil_bottle_15l">Oil Bottle (15L)</option>
                <option value="cake">Cake</option>
                <option value="groundnut">Groundnut</option>
              </select>
            </div>
            <div className="form-group col-12 mb-3">
              <label className="form-label">Price</label>
              <input
                type="number"
                name="price"
                className="form-control"
                value={calculator.price}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group col-12 mb-3">
              <label className="form-label">Customer Name</label>
              <input
                type="text"
                name="customer_name"
                className="form-control"
                value={calculator.customer_name}
                onChange={handleChange}
                placeholder="Customer Name"
                required
              />
            </div>
            <div className="form-group col-12 mb-3">
              <label className="form-label">Customer Mobile</label>
              <input
                type="tel"
                name="customer_mobile"
                className="form-control"
                value={calculator.customer_mobile}
                onChange={handleChange}
                placeholder="Customer Mobile"
                pattern="[0-9]{10}"
                title="Enter a valid 10 digit mobile number"
                required
              />
              {lastSaleLoading && (
                <small className="text-muted">Loading last sale data...</small>
              )}
              {lastSaleError && (
                <small className="text-danger d-block">{lastSaleError}</small>
              )}
            </div>
            <div className="form-group col-12 mb-3">
              <label className="form-label">Quantity</label>
              <input
                type="number"
                name="qty"
                className="form-control"
                value={calculator.qty}
                onChange={handleChange}
                required
                min="1"
              />
            </div>
            <div className="form-group col-12 mb-3">
              <label className="form-label">Total</label>
              <input
                type="text"
                name="total"
                className="form-control fw-bold"
                value={calculator.total}
                disabled
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={handleSubmit}
            disabled={loading}
            className="px-4"
          >
            {loading ? "Saving..." : "Save"}
          </Button>
          {error && <div className="text-danger mt-2">{error}</div>}
          {success && <div className="text-success mt-2">{success}</div>}
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default SalePOPUP;
